import { useTranslation } from 'react-i18next';

import { SVGIconType } from '../../../constants/svgIcon';
import { LightSwipe, SvgIcon } from '../../Molecules';

import styles from './HomeClubCardGroup.module.css';

type HomeClubCardGroupProps = {
  onClickRevisionDetail: () => void;
};

export const HomeClubCardGroup = (props: HomeClubCardGroupProps) => {
  const { onClickRevisionDetail } = props;
  const { t } = useTranslation();

  return (
    <div className={styles.cardRow}>
      <div className={styles.cardContainerBlue}>
        <div className={styles.topSection}>
          <div className={styles.titleCardRow}>
            {/* <div className={styles.greenCardHeader}>
              {t('Auto-Scheduled Daily Practice')}
            </div> */}
            <div className={styles.greenCardHeader}>
              {t('Long-Term Memory')}
            </div>
            {/* <div
              className={`${styles.infoTitleContainer} ${styles.hoverStyle}`}
              onClick={onClickPracticeDetail}
            >
              <SvgIcon
                name={SVGIconType.GameInstruction}
                width={24}
                height={24}
                color={'#808080'}
              />
            </div> */}
          </div>
          <hr className={styles.divider} />
        </div>

        <div className={styles.hContainer}>
          <SvgIcon
            name={SVGIconType.Brain}
            width={24}
            height={24}
            color={'#eb8c36'}
          />
          <div className={styles.orangeText}>{`${10}%`}</div>
          <SvgIcon
            name={SVGIconType.DirectArrow}
            width={24}
            height={24}
            color={'#808080'}
          />
          <SvgIcon
            name={SVGIconType.Brain}
            width={24}
            height={24}
            color={'#00a698'}
          />
          <div className={styles.cyanText}>{`${90}%+`}</div>
        </div>

        <div
          className={styles.startNowContainer}
          onClick={onClickRevisionDetail}
        >
          <SvgIcon
            name={SVGIconType.MemoryWithAI}
            width={24}
            height={24}
            color={'#ffffff'}
            className={styles.aiIcon}
          />
          <div
            className={styles.whiteText}
            style={{
              color: '#ffffff',
              fontWeight: 'bold',
              fontSize: '1rem',
            }}
          >
            {t('Start!')}
          </div>
          <SvgIcon
            name={SVGIconType.Play}
            width={22}
            height={22}
            color={'#ffffff'}
            className={styles.playIcon}
          />
          <LightSwipe height={38} />
        </div>
      </div>
    </div>
  );
};

// type PerformanceReportCardProps = {
//   gamePlayed: number;
//   topSectionRef: React.RefObject<HTMLDivElement>;
//   onClickPerformanceReport: () => void;
// };

// export const PerformanceReportCard = (props: PerformanceReportCardProps) => {
//   const { gamePlayed, topSectionRef, onClickPerformanceReport } = props;
//   const { t } = useTranslation();

//   return (
//     <div className={styles.cardContainer}>
//       <div className={styles.topSection} ref={topSectionRef}>
//         <div className={styles.orangeCardHeader}>{t('Difficult Words')}</div>
//         <div className={styles.cardHeader}>{t('Daily Learning')}</div>
//         <hr className={styles.divider} />
//       </div>

//       <div className={styles.vContainer}>
//         <div className={styles.blackTitle}>{t('Items Revised Today')}</div>
//       </div>
//       <div className={styles.vContainer}>
//         <div className={styles.hContainer}>
//           <SvgIcon
//             name={SVGIconType.Game}
//             width={26}
//             height={26}
//             color={'#333'}
//           />
//           <div className={styles.reportNumber}>{gamePlayed}</div>
//         </div>
//       </div>

//       <div className={styles.vContainer}>
//         <div className={styles.greyTitle}>
//           {t('Input difficult words for learning')}
//         </div>
//         {/* <div className={styles.hContainer}>
//           <SvgIcon
//             name={SVGIconType.DoubleScore}
//             width={24}
//             height={24}
//             color={'#333'}
//           />
//           <div className={styles.reportNumber}>{avgScore}</div>
//         </div> */}
//       </div>

//       <div className={styles.buttonContainer}>
//         <TextButton
//           text={t('Enter')}
//           onClick={onClickPerformanceReport}
//           isLightSwipe={true}
//           variant={TextButtonVariant.Orange}
//         />
//       </div>
//     </div>
//   );
// };

// type AIMemoryBoostCardProps = {
//   data?: MemoryPanelData[];
//   currentMemoryRetention: number;
//   revisedNumber: number;
//   memoryBeforeAfter: MemoryBeforeAfter | undefined;
//   topSectionRef: React.RefObject<HTMLDivElement>;
//   onClickStartAIRevision: () => void;
// };

// export type MemoryBeforeAfter = {
//   before: number;
//   after: number;
// };

// // this is exam revision
// export const AIMemoryBoostCard = (props: AIMemoryBoostCardProps) => {
//   const {
//     revisedNumber,
//     memoryBeforeAfter,
//     topSectionRef,
//     onClickStartAIRevision,
//   } = props;
//   const { t } = useTranslation();
//   return (
//     <div className={styles.cardContainer}>
//       <div className={styles.topSection} ref={topSectionRef}>
//         <div className={styles.greenCardHeader}>{t('Exam Revision')}</div>
//         <div className={styles.cardHeader}>{t('Daily Revision')}</div>
//         <hr className={styles.divider} />
//       </div>
//       <div className={styles.blackTitle}>{t('Items Revised Today')}</div>
//       <div className={styles.hContainer}>
//         <SvgIcon
//           name={SVGIconType.MemoryWithAI}
//           width={26}
//           height={26}
//           color={'#333'}
//         />
//         <div className={styles.reportNumber}>{`${revisedNumber}`}</div>
//       </div>

//       <div className={styles.greyTitle}>
//         {t('Enhance your memory retention by up to 9 times.')}
//       </div>
//       <div className={styles.buttonContainer}>
//         <TextButton
//           text={t('Enter')}
//           onClick={onClickStartAIRevision}
//           variant={
//             memoryBeforeAfter === undefined ? TextButtonVariant.Gray : undefined
//           }
//           isLightSwipe={memoryBeforeAfter !== undefined}
//         />
//       </div>
//     </div>
//   );
// };
